<!-- <app-navbar-style-two></app-navbar-style-two> -->
<div class="post_page">

  <div class="spinner-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>
  
  <!-- nav-menu -->

  <div class="nav_menu">
    <div class="fix_top">
      <div class="nav">
        <div class="logo">
          <a routerLink="/">
            <img class="d-block d-lg-none small-logo" src="../../../../assets/img/logo.png" alt="logo">
            <img class="d-none d-lg-block" src="../../../../assets/img/logo.png" alt="logo"
              style="width: 100px; padding-bottom: 10px;">
          </a>
        </div>
        <div class="menu">
          <ul>
            <li>
              <a class="active" href="#">
                <i href="#" class="bi bi-house-door" style="font-size: 17px;" ></i>&nbsp;&nbsp;
                <span class="d-none d-lg-block">Main Page</span>
              </a>
            </li>
            <li>
              <a class="active">
                <i class="bi bi-house-door" style="font-size: 17px;" (click)="toggleMenuOption('Home')"></i>&nbsp;&nbsp;
                <span class="d-none d-lg-block" (click)="toggleMenuOption('Home')">Home</span>
              </a>
            </li>
            <li id="search_icon" style="cursor: pointer;">
              <a (click)="toggleSearch()">
                <i class="bi bi-search" style="font-size: 16px;"></i>&nbsp;&nbsp;
                <span class="d-none d-lg-block search">Search</span>
              </a>
            </li>
            <!-- <li>
              <a>
                <svg aria-label="Explore" class="x1lliihq x1n2onr6 x5n08af" fill="currentColor" height="20" role="img"
                  viewBox="0 0 24 24" width="18">
                  <title>Explore</title>
                  <path
                    d="m13.173 13.164 1.491-3.829-3.83 1.49ZM12.001.5a11.5 11.5 0 1 0 11.5 11.5A11.513 11.513 0 0 0 12.001.5Zm5.35 7.443-2.478 6.369a1 1 0 0 1-.57.569l-6.36 2.47a1 1 0 0 1-1.294-1.294l2.48-6.369a1 1 0 0 1 .57-.569l6.359-2.47a1 1 0 0 1 1.294 1.294Z">
                  </path>
                </svg>&nbsp;&nbsp;
                <span class="d-none d-lg-block">Explore</span>
              </a>
            </li> -->
            <li>
              <a (click)="toggleMenuOption('Reels')">
                <svg aria-label="Reels" class="x1lliihq x1n2onr6 x5n08af" fill="currentColor" height="24" role="img"
                  viewBox="0 0 24 24" width="17">
                  <title>Reels</title>
                  <line fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="2" x1="2.049" x2="21.95"
                    y1="7.002" y2="7.002"></line>
                  <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2" x1="13.504" x2="16.362" y1="2.001" y2="7.002"></line>
                  <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2" x1="7.207" x2="10.002" y1="2.11" y2="7.002"></line>
                  <path
                    d="M2 12.001v3.449c0 2.849.698 4.006 1.606 4.945.94.908 2.098 1.607 4.946 1.607h6.896c2.848 0 4.006-.699 4.946-1.607.908-.939 1.606-2.096 1.606-4.945V8.552c0-2.848-.698-4.006-1.606-4.945C19.454 2.699 18.296 2 15.448 2H8.552c-2.848 0-4.006.699-4.946 1.607C2.698 4.546 2 5.704 2 8.552Z"
                    fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  </path>
                  <path
                    d="M9.763 17.664a.908.908 0 0 1-.454-.787V11.63a.909.909 0 0 1 1.364-.788l4.545 2.624a.909.909 0 0 1 0 1.575l-4.545 2.624a.91.91 0 0 1-.91 0Z"
                    fill-rule="evenodd"></path>
                </svg>&nbsp;&nbsp;
                <span class="d-none d-lg-block" (click)="toggleMenuOption('Reels')">Reels</span>
              </a>
            </li>
            <!-- <li>
              <a href="./me">
                <i class="bi bi-chat-left-text" style="font-size: 17px;"></i> &nbsp;&nbsp;
                <span class="d-none d-lg-block">Messages</span>
              </a>
            </li> -->
            <!-- <li class="notification_icon">
              <a href="#">
                <i class="bi bi-bell" style="f  ont-size: 17px;"></i>&nbsp;&nbsp;
                <span class="d-none d-lg-block">Notifications</span>
              </a>
            </li> -->
            <li>
              <a data-bs-toggle="modal" data-bs-target="#create_modal" *ngIf="IsLoginAdmin == true">
                <i class="bi bi-plus-circle" style="font-size: 17px;"></i>&nbsp;&nbsp;
                <span class="d-none d-lg-block">Create</span>
              </a>
            </li>
            <li>
              <a *ngIf="IsLoginAdmin == true">
                <img class="circle story" src="../../../../assets/images/profile_img.jpg">
                <span class="d-none d-lg-block" (click)="toggleMenuOption('Profile')">Profile</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="more">
          <div class="btn-group dropup">
            <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <img src="../../../../assets/images/menu.png">
              <span class="d-none d-lg-block">More</span>
            </button>
            <!-- <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="#">
                  <span>Settings</span>
                  <img src="../../../../assets/images/reglage.png">
                </a></li>
              <li><a class="dropdown-item" href="#">
                  <span>Your activity</span>
                  <img src="../../../../assets/images/history.png">
                </a></li>
              <li><a class="dropdown-item" href="#">
                  <span>Saved</span>
                  <img src="../../../../assets/images/save-instagram.png">
                </a></li>
              <li><a class="dropdown-item" href="#">
                  <span>Switch appearance</span>
                  <img src="../../../../assets/images/moon.png">
                </a></li>
              <li><a class="dropdown-item" href="#">
                  <span>Report a problem</span>
                  <img src="../../../../assets/images/problem.png">
                </a></li>
              <li><a class="dropdown-item bold_border" href="#">
                  <span>Switch accounts</span>
                </a></li>
              <li><a class="dropdown-item" href=".">
                  <span>Log out</span>
                </a></li>
            </ul> -->
          </div>
        </div>
      </div>
      <div class="nav_sm">
        <div class="content">
          <div class="dropdown">
            <button class="btn btn-secondary dropdown-toggle" type="button">
              <img class="logo" src="../../../../assets/img/logo.png">
            </button>
            <!-- <ul class="dropdown-menu">
                  <li><a class="dropdown-item" href="#">
                    <span>Following</span>
                    <img src="../../../../assets/images/add-friend.png">
                  </a></li>
                  <li><a class="dropdown-item" href="#">
                    <span>Favorites</span>
                    <img src="../../../../assets/images/star.png">
                  </a></li>
                </ul> -->
          </div>
          <div class="left">
            <div class="search_bar">
              <div class="input-group">
                <div class="form-outline">
                  <div>
                    <img src="../../../../assets/images/search.png" alt="search">
                  </div>
                  <input type="search" id="form1" class="form-control" placeholder="Search" />
                </div>
              </div>
            </div>
            <div class="notifications notification_icon">
              <a href="./notifi">
                <img src="../../../../assets/images/love.png">
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div class="nav_xm">
        <div class="dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            <img class="logo" src="../../../../assets/img/logo.png">
          </button>
          <!-- <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#">
                  <span>Following</span>
                  <img src="../../../../assets/images/add-friend.png">
                </a></li>
                <li><a class="dropdown-item" href="#">
                  <span>Favorites</span>
                  <img src="../../../../assets/images/star.png">
                </a></li>
              </ul> -->
        </div>
        <div class="left">
          <img src="../../../../assets/images/send.png">
          <a>
            <img class="notification_icon" src="../../../../assets/images/love.png">
          </a>
        </div>
      </div>
    </div>
    <div class="nav_bottom">
      <a href=""><img src="../../../../assets/images/accueil.png"></a>
      <a><img src="../../../../assets/images/compass.png"></a>
      <a><img src="../../../../assets/images/video.png"></a>
      <a href="#" data-bs-toggle="modal" data-bs-target="#create_modal"><img
          src="../../../../assets/images/tab.png"></a>
      <a><img class="circle story" src="../../../../assets/images/profile_img.jpg"></a>
    </div>
  </div>
  <!-- search -->
  <div id="search" class="search_section" [ngClass]="{'show': isSearchVisible}" 
  
  >
  <div  tabindex="0"
  (focusout)="onSearchBoxFocusOut()">
    <h2>Search</h2>
    <form method="post">
      <input type="text" placeholder="Search" name="searchQuery" (ngModelChange)="filterUserAccounts()"
       [(ngModel)]="searchQuery">
       <i class="bi bi-search "></i>
    </form>
    <div class="find">
      <div class="desc">
        <h4>Recent</h4>
        <p><a href="#">Clear all</a></p>
      </div>
      <div style="max-height: 400px;
    overflow-y: auto;">

<div class="account" *ngFor="let user of filteredUserAccounts" >
  <div class="cart">
    <div>
      <div >
      <div class="img">
        <img src="../../../../assets/images/profile_img.jpg" alt="">
      </div>
      <div class="info">
        <p class="name">{{user.User_Name}}</p>
        <p class="second_name">Zim Ess</p>
      </div>
    </div>
    </div>
    <div class="clear">
      <a href="#">X</a>
    </div>
  </div>
</div>
      </div>
      
    </div>
  </div>
    
  </div>

  <div id="notification" class="notification_section">
    <h2>Notifications</h2>
    <div class="notifications">
      <div class="notif follow_notif">
        <div class="cart">
          <div>
            <div class="img">
              <img src="../../../.../../../../assets/images/profile_img.jpg" alt="">
            </div>
            <div class="info">
              <p class="name">
                Zineb_essoussi
                <span class="desc">started following you.</span>
                <span class="time">2h</span>
              </p>
            </div>
          </div>
          <div class="follow_you">
            <button class="follow_text">Follow</button>
          </div>
        </div>
      </div>
      <div class="notif follow_notif">
        <div class="cart">
          <div>
            <div class="img">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
            </div>
            <div class="info">
              <p class="name">
                Zineb_essoussi
                <span class="desc">started following you.</span>
                <span class="time">2h</span>
              </p>
            </div>
          </div>
          <div class="follow_you">
            <button class="follow_text">Follow</button>
          </div>
        </div>
      </div>
      <div class="notif story_notif">
        <div class="cart">
          <div>
            <div class="img">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
            </div>
            <div class="info">
              <div class="info">
                <p class="name">
                  Zineb_essoussi
                  <span class="desc">liked your story.</span>
                  <span class="time">2d</span>
                </p>
              </div>
            </div>
          </div>
          <div class="story_like">
            <img src="../../../../assets/images/img2.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="notif follow_notif">
        <div class="cart">
          <div>
            <div class="img">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
            </div>
            <div class="info">
              <p class="name">
                Zineb_essoussi
                <span class="desc">started following you.</span>
                <span class="time">2h</span>
              </p>
            </div>
          </div>
          <div class="follow_you">
            <button class="follow_text">Follow</button>
          </div>
        </div>
      </div>
      <div class="notif story_notif">
        <div class="cart">
          <div>
            <div class="img">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
            </div>
            <div class="info">
              <div class="info">
                <p class="name">
                  Zineb_essoussi
                  <span class="desc">liked your story.</span>
                  <span class="time">2d</span>
                </p>
              </div>
            </div>
          </div>
          <div class="story_like">
            <img src="../../../../assets/images/img2.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="notif follow_notif">
        <div class="cart">
          <div>
            <div class="img">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
            </div>
            <div class="info">
              <p class="name">
                Zineb_essoussi
                <span class="desc">started following you.</span>
                <span class="time">2h</span>
              </p>
            </div>
          </div>
          <div class="follow_you">
            <button class="follow_text">Follow</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- comment model -->
  <div  class="modal fade" id="message_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" style="box-shadow: 5px 5px #16f5f5;
    border: 1px solid #96e3e3;">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Comments</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" style="max-height: 400px; overflow-y: auto;">
          <div class="comments" *ngFor="let comment of allReelsCommentsDetails; let index = index">
            <!-- *ngFor="let comment of reelsDetailsList.reelsCommentsDetailsList" -->
            <div class="comment">
              <div class="d-flex">
                <div class="img">
                  <img src="../../../../assets/images/profile_img.jpg" alt="">
                </div>
                <div class="content">
                  <div class="person">
                    <h4>{{comment.USER_NAME}}</h4>
                    <span>{{ getTimeAgo(comment.CREATED_DATE) }}</span>
                  </div>
                  <p>{{comment.COMMENT}}</p>
                  <div class="replay">
                    <button class="replay" 
                    (click)="isPublicUser == true ? userToken() : wantToReplay(comment.USER_ID, comment.REELS_COMMENTS_DETAILS_ID)"
                    >replay</button>
                    <button class="translation">see translation</button>
                  </div>
                  <div class="answers" *ngIf="comment.replies && comment.replies.length > 0">
                    <button class="see_comment" (click)="toggleReplies(index)">
                      <!-- <span class="hide_com">Hide all responses</span> -->
                      <span class="hide_com">{{ isReplyVisible[index] ? 'Hide Replies' : 'Show Replies' }}</span>
                      <span class="show_c"></span> See the <span>{{ comment.replies.length }}</span> answers

                      <!-- <span class="show_c"> <span class="line"></span> See the <span> 1 </span> answers</span> -->
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div class="like">
                <img class="not_loved" src="../../../../assets/images/love.png" alt="">
                <img class="loved" src="../../../../assets/images/heart.png" alt="">
                <p> 55</p>
              </div> -->

              <div class="like" 
              (click)="isPublicUser == true ? userToken() : toggleLikeTest(comment, index)"
              >
                <img [ngClass]="{ 'not_loved': !comment.IS_LIKED, 'loved': comment.IS_LIKED }" src="../../../../assets/images/heart.png" alt="Like">
                <p>{{ comment.COMMENT_LIKE }}</p>
              </div>

            </div>
            <div *ngIf="isReplyVisible[index]">
              <div class="responses" *ngFor="let replay of comment.replies; let indexC = index">
              <div class="response comment">
                <div class="d-flex">
                  <div class="img">
                    <img src="../../../../assets/images/profile_img.jpg" alt="">
                  </div>
                  <div class="content">
                    <div class="person">
                      <h4>{{comment.USER_NAME}}</h4>
                        <span>{{ getTimeAgo(replay.CREATED_DATE) }}</span>
                    </div>
                      <p>{{replay.REPLAY_COMMENT}}</p>
                    <div class="replay">
                      <button>replay</button>
                      <button>see translation</button>
                    </div>
                  </div>
                </div>
                  <!-- <div class="like">
                  <img class="not_loved" src="../../../../assets/images/love.png" alt="">
                  <img class="loved" src="../../../../assets/images/heart.png" alt="">
                  <p> 55</p>
                  </div> -->
                  <div class="like" 
                  (click)="isPublicUser == true ? userToken() : toggleLikeTest(replay, indexC, true)"
                  >
                    <img [ngClass]="{ 'not_loved': !replay.IS_LIKED, 'loved': replay.IS_LIKED }" src="../../../../assets/images/heart.png" alt="Like">
                    <p>{{ replay.IS_REPLAY_LIKES }}</p>
                </div>
              </div>
            </div>
          </div>
            
        </div>
        </div>
        <div class="modal-footer">
          <form method="post">
            <div class="input">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
              <!-- <input type="text" id="emoji_comment" 
              [(ngModel)]="this.reelsCommentsModel.COMMENT"
              placeholder="Add a comment..." /> -->
          <input type="text" #commentInput name="comment-input" [(ngModel)]="this.reelsCommentsModel.COMMENT" id="emoji_comment" placeholder="Add a comment..." />

              <button 
              type="button" class="comment-btn" 
               data-bs-dismiss="modal" aria-label="Close"
              (click)="isPublicUser == true ? userToken() : postComment()"
              [disabled]="!reelsCommentsModel.COMMENT || reelsCommentsModel.COMMENT.trim() === ''"

              >
                <i class="fa fa-paper-plane"></i> <!-- or use an appropriate send icon -->
              </button>
            </div>
          </form>
        </div>
        <!-- <div class="input">
          <img src="../../../../assets/images/profile_img.jpg" alt="Profile Picture">
          <input type="text" #commentInput name="comment-input" [(ngModel)]="this.reelsCommentsModel.COMMENT" id="emoji_comment" placeholder="Add a comment..." />
          <button type="button" class="comment-btn" (click)="postComment()">
            <i class="fa fa-paper-plane"></i> 
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <!-- next model -->

  <div class="modal fade" id="send_message_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" style="box-shadow: 5px 5px #16f5f5;
    border: 1px solid #96e3e3;">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Share</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="send">
            <div class="search_person">
              <p>To:</p>
              <input type="text" placeholder="Search">
            </div>
            <p>Suggested</p>
            <div class="people">
              <div class="person">
                <div class="d-flex">
                  <div class="img">
                    <img src="../../../../assets/images/profile_img.jpg" alt="">
                  </div>
                  <div class="content">
                    <div class="person">
                      <h4>namePerson</h4>
                      <span>zim ess</span>
                    </div>
                  </div>
                </div>
                <div class="circle">
                  <span></span>
                </div>
              </div>
              <div class="person">
                <div class="d-flex">
                  <div class="img">
                    <img src="../../../../assets/images/profile_img.jpg" alt="">
                  </div>
                  <div class="content">
                    <div class="person">
                      <h4>namePerson</h4>
                      <span>zim ess</span>
                    </div>
                  </div>
                </div>
                <div class="circle">
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" style="border:1px solid #0ec6c6;background-color: transparent;color: #0ec6c6;">Send</button>
        </div>
      </div>
    </div>
  </div>

 <!-- next model -->
 <div class="modal fade custom-modal" id="create_modal" tabindex="-1" aria-labelledby="exampleModalLabel"
 aria-hidden="true">
 <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
   <div class="modal-content">
     <div class="modal-header">
       <h1 class="modal-title w-100 fs-5 d-flex align-items-end justify-content-between" id="exampleModalLabel">
         <span class="title_create">Create new post</span>
         <button class="next_btn_post btn_link"></button>
       </h1>
       <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
     </div>
     <div class="modal-body" style="overflow-y: auto !important;">
       <img class="up_load" src="../../../../assets/images/upload.png" alt="upload">
       <h3>Gallery</h3>
       <p class="py-0" style="padding: 0px;margin: 17px 0px 0px 0px;">Drag photos and videos here</p>
       <div>
         <div class="add-listings-box">

           <dropzone id="p-uploadimg-dropzone" [config]="config" [message]="'Drag photos and videos here'"
             class="custom-dropzone" (maxFilesExceeded)="onMaxFilesExceeded()"
             (maxFilesReached)="onMaxFilesReached()" (removedFile)="onRemoveFile($event)"
             (error)="onUploadError($event)" (success)="onUploadSuccess($event, true)" (canceled)="onCanceled($event)">
           </dropzone>
           <div class="d-flex justify-content-center">
             <button class="btn btn-primary btn_upload" style="width: 100%;
 max-width: 270px; border:1px solid #0ec6c6;background-color: transparent;color: #0ec6c6;"
               (click)="addUpdateReelsStatus()">
               Post
             </button>
           </div>
         </div>
         <!-- <div class="col-md-12">
           <ol id="ol-uploadimg-imgname" class="custom-file-list">
             <li *ngFor="let fileName of uploadedFilesName; let ndx=index" [id]="'opt-uploadimg-imgname-'+ndx">
               <a [id]="'a-imgname-'+ndx" href="FoxDocumentDirectory\RequestForOrder\UploadImages\{{fileName}}" target="_blank">{{fileName}}</a>
             </li>
           </ol>
         </div> -->
         <!-- <div class="clearfix"></div>
         <dropzone id="p-uploadimg-dropzone" [config]="config" [message]="'Drag photos and videos here'" 
           class="custom-dropzone"
           (maxFilesExceeded)="onMaxFilesExceeded()"
           (maxFilesReached)="onMaxFilesReached()" 
           (removedFile)="onRemoveFile($event)" 
           (error)="onUploadError($event)"
           (success)="onUploadSuccess($event)" 
           (canceled)="onCanceled($event)">
         </dropzone> -->
       </div>
     </div>
   </div>
 </div>
</div>

  
  <!-- story model -->
  <div class="modal fade" id="create_modal-story" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title w-100 fs-5 d-flex align-items-end justify-content-between" id="exampleModalLabel">
            <span class="title_create">Create new story</span>
            <button class="next_btn_post btn_link"></button>
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="clearDropzone()"></button>
        </div>
        <div class="modal-body" style="overflow-y: auto !important;">
          <img class="up_load" src="../../../../assets/images/upload.png" alt="upload">
          <!-- <h3>Gallery</h3> -->
          <p style="padding: 0px; margin: 0px;">Drag photos and videos here</p>

          <div>
            <!-- <div class="col-md-12">
              <ol id="ol-uploadimg-imgname">
                <li *ngFor="let fileName of uploadedFilesName; let ndx=index" [id]="'opt-uploadimg-imgname-'+ndx"><a
                    [id]="'a-imgname-'+ndx" href="FoxDocumentDirectory\RequestForOrder\UploadImages\{{fileName}}"
                    target="_blank">{{fileName}}</a></li>
              </ol>
            </div> -->

            <div class="clearfix"></div>

            <dropzone  #dropzoneComponent id="p-uploadimg-dropzone" [config]="config" [message]="'Drag photos and videos here'"
              (maxFilesExceeded)="onMaxFilesExceeded()" (maxFilesReached)="onMaxFilesReached()"
              (removedFile)="onRemoveFile($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)"
              (canceled)="onCanceled($event)"></dropzone>
          </div>
          <!-- <button class="btn btn-primary btn_upload" style="width: 100%;
    max-width: 270px; border:1px solid #0ec6c6;background-color: transparent;color: #0ec6c6;">
            select from your device
            <form id="upload-form">
              <input class="input_select" type="file" id="image-upload" name="image-upload">
            </form>
          </button> -->
          <button class="btn btn-primary btn_upload" style="width: 100%;
    max-width: 270px;margin-top: 10px; border:1px solid #0ec6c6;background-color: transparent;color: #0ec6c6;"
            (click)="addUpdateReels()" >
            Post
          </button>

          <!-- <div class="add-listings-box">
            <h3>Gallery</h3>
            <div>
                <div class="col-md-12">
                    <ol id="ol-uploadimg-imgname">
                        <li *ngFor="let fileName of uploadedFilesName; let ndx=index" [id]="'opt-uploadimg-imgname-'+ndx"><a [id]="'a-imgname-'+ndx" href="FoxDocumentDirectory\RequestForOrder\UploadImages\{{fileName}}"
                                target="_blank">{{fileName}}</a></li>
                    </ol>
                </div>
                
                <div class="clearfix"></div>
                
                <dropzone id="p-uploadimg-dropzone" [config]="config" [message]="'Click or Drag Images and Documents here to upload (.pdf, .png, .jpg/.jpeg, .tif/.tiff, .bmp)'" (maxFilesExceeded)="onMaxFilesExceeded()"
        (maxFilesReached)="onMaxFilesReached()" (removedFile)="onRemoveFile($event)" (error)="onUploadError($event)"
        (success)="onUploadSuccess($event)" (canceled)="onCanceled($event)"></dropzone>
            </div>
        </div> -->



          <div id="image-container" class="hide_img"></div>
          <div id="image_description" class="hide_img">
            <div class="img_p"></div>
            <div class="description">
              <div class="cart">
                <div>
                  <div class="img">
                    <img src="../../../../assets/images/profile_img.jpg">
                  </div>
                  <div class="info">
                    <p class="name">Zineb_essoussi</p>
                  </div>
                </div>
              </div>
              <form>
                <textarea type="text" id="emoji_create" placeholder="write your email"></textarea>
              </form>
            </div>
          </div>
          <div class="post_published hide_img">
            <img src="../../../../assets/images/uploaded_post.gif" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Start Main Banner Area -->

<div class="story-overlay" *ngIf="showStory">
  <div class="reel-container">
    <button class="close-button" (click)="closeReel()">X</button>
    <div class="navigation-buttons">
      <button class="prev-button" (click)="previousStory()">
        <img src="assets/icons/left-arrow.svg" alt="Previous" />
      </button>
      <button class="next-button" (click)="nextStory()">
        <img src="assets/icons/right-arrow.svg" alt="Next" />
      </button>
    </div>
    <div class="reel-item" *ngFor="let reel of reelsDetailsList; let i = index" [ngClass]="{'active': selectedIndex === i}">
      <div class="video-wrapper">
        <video [id]="'video-' + i" [src]="reel.uploadedFilesName" autoplay loop controls></video>
      </div>
      <div class="status-bar-wrapper">
        <div class="status-bar" *ngFor="let reel of reelsDetailsList; let j = index" [ngClass]="{'active': selectedIndex === j}"></div>
      </div>
      <div class="reel-footer">
        <div class="reel-actions">
          <button class="like-button" (click)="likeReel()">
            <span class="heart-icon" [ngClass]="{'liked': isLiked}">&#9829;</span>
            Like
          </button>
          <button class="comment-button" (click)="showCommentInput()">Comment</button>
          <button class="share-button" (click)="shareReel()">Share</button>
        </div>
        <div class="comment-section" *ngIf="showComment">
          <input type="text" placeholder="Add a comment..." [(ngModel)]="commentText" />
          <button (click)="postComment()">Post</button>
        </div>
      </div>
    </div>
  </div>
</div>
 <!-- post-detail-model -->
 <div *ngIf="isPopupVisible" class="popup-modal">
     
  <button class="prev-button">
    <i class="flaticon-left-chevron"></i>
  </button>
  <button class="next-button"  >
    <i class="flaticon-right-chevron"></i>
  </button>

<div class="cross-icon" (click)="togglePopupClose()">
  <i class="bi bi-x-lg"></i>
</div>
<div class="popup-content">
   <div class="row g-0">
    <div class="col-12 col-md-6 col-lg-5">
      <div class="postDetailslider">
        


        <!-- <owl-carousel-o #carousel [options]="PostDetailSlider">
          <ng-container *ngFor="let video of reelsDetailsListSaved; let i = index" class="new-reel-item" (click)="togglePopup()">
            <ng-template carouselSlide>
              <div class="img-container">
                <img [src]="image.src" [alt]="image.alt">
                <video #videoElement [id]="'video-' + i" [src]="video.uploadedFilesName" class="new-video"  loop></video>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o> -->



          <div class="img-container" *ngFor="let video of reelsDetailsListSaved; let i = index"
          (click)="toggleProfilePlay(this.selectiveSavedIndex)"
          >
   
            <video
             #videoProfileElement [id]="'video-' + i" style="height: 100% !important;width: 100%;"
             [src]="video.uploadedFilesName"   loop ></video>
           
             <div class="custom-content">
              <div class="custom-sound" (click)="toggleProfileMute(this.selectiveSavedIndex)">
                <img class="volume-up" src="../../../../assets/images/volume-up.png" *ngIf="!video.isMuted">
                <img class="volume-mute" src="../../../../assets/images/volume-mute.png" *ngIf="video.isMuted">
              </div>
              <div class="custom-play" 
               
                [ngClass]="{'opac_1': !video.isPlaying}">
                <img src="../../../../assets/images/play-button-arrowhead.png" *ngIf="!video.isPlaying">
              </div>
            </div>
          </div>


          
         

        <!-- <owl-carousel-o #carousel [options]="PostDetailSlider">
          <ng-container *ngFor="let image of postDetailImages; let i = index">
            <ng-template carouselSlide>
              <div class="img-container">
                <img [src]="image.src" [alt]="image.alt">
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o> -->
      </div>
      
     </div>
     <div class="col-12 col-md-6 col-lg-7   d-flex flex-column justify-content-around">
      <div class="post-detail-top">
         <div class="info">
          <div class="person">
              <img src="https://i.ibb.co/3S1hjKR/account1.jpg">
              <a href="#">zineb</a>
              <span class="circle">.</span>
              <span>45m</span>
          </div>
          <div class="more">
              <img src="../../../../assets/images/show_more.png" alt="show more">
          </div>
        </div>
        <!-- story comment -->
    <div class="comment-container">
      <div class="comments" *ngFor="let comment of allReelsCommentsDetails; let index = index">
        <!-- *ngFor="let comment of reelsDetailsList.reelsCommentsDetailsList" -->
        <div class="comment" style="padding-right: 10px;">
          <div class="d-flex">
            <div class="img">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
            </div>
            <div class="content">
              <div class="person">
                <h4>{{comment.USER_NAME}}</h4>
                <span>{{ getTimeAgo(comment.CREATED_DATE) }}</span>
              </div>
              <p>{{comment.COMMENT}}</p>
              <div class="replay">
                <button class="replay" (click)="wantToReplay(comment.USER_ID, comment.REELS_COMMENTS_DETAILS_ID)">replay</button>
                <button class="translation">see translation</button>
              </div>
              <div class="answers" *ngIf="comment.replies && comment.replies.length > 0">
                <button class="see_comment" (click)="toggleReplies(index)">
                  <!-- <span class="hide_com">Hide all responses</span> -->
                  <span class="hide_com">{{ isReplyVisible[index] ? 'Hide Replies' : 'Show Replies' }}</span>
                  <span class="show_c"></span> See the <span>{{ comment.replies.length }}</span> answers

                  <!-- <span class="show_c"> <span class="line"></span> See the <span> 1 </span> answers</span> -->
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="like">
            <img class="not_loved" src="../../../../assets/images/love.png" alt="">
            <img class="loved" src="../../../../assets/images/heart.png" alt="">
            <p> 55</p>
          </div> -->

          <div class="like" 
          (click)="isPublicUser == true ? userToken() : toggleLikeTest(comment, index)"
          >
            <img [ngClass]="{ 'not_loved': !comment.IS_LIKED, 'loved': comment.IS_LIKED }" src="../../../../assets/images/heart.png" alt="Like">
            <p>{{ comment.COMMENT_LIKE }}</p>
          </div>

        </div>

        <div *ngIf="isReplyVisible[index]">
          <div class="responses" *ngFor="let replay of comment.replies; let indexC = index">
          <div class="response comment">
            <div class="d-flex">
              <div class="img">
                <img src="../../../../assets/images/profile_img.jpg" alt="">
              </div>
              <div class="content">
                <div class="person">
                  <h4>{{comment.USER_NAME}}</h4>
                    <span>{{ getTimeAgo(replay.CREATED_DATE) }}</span>
                </div>
                  <p>{{replay.REPLAY_COMMENT}}</p>
                <div class="replay">
                  <button>replay</button>
                  <button>see translation</button>
                </div>
              </div>
            </div>
              <!-- <div class="like">
              <img class="not_loved" src="../../../../assets/images/love.png" alt="">
              <img class="loved" src="../../../../assets/images/heart.png" alt="">
              <p> 55</p>
              </div> -->
              <div class="like" 
              (click)="isPublicUser == true ? userToken() : toggleLikeTest(replay, indexC, true)"
              >
                <img [ngClass]="{ 'not_loved': !replay.IS_LIKED, 'loved': replay.IS_LIKED }" src="../../../../assets/images/heart.png" alt="Like">
                <p>{{ replay.IS_REPLAY_LIKES }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
      <div class="sending-container">
      
        <div class="desc">
          <div class="icons">
              <div class="icon_left d-flex justify-content-center align-items-center">
                  <!-- <div class="like">
                      <img class="not_loved" src="../../../../assets/images/love.png">
                      <img class="loved" src="../../../../assets/images/heart.png">
                  </div> -->
                  <div class="like" (click)="toggleLike(selectiveSavedIndex, this.reelsDetailsListSaved[0])" >
                    <!-- <img *ngIf="!video.liked" class="not_loved" src="../../../../assets/images/love.png" alt="Not Loved">
                    <img *ngIf="video.liked" class="loved" src="../../../../assets/images/heart.png" alt="Loved">
                    <p>{{ video.likesCount }}</p> -->
                    <img [ngClass]="{ 'not_loved': !this.reelsDetailsListSaved[0].IS_REEL_LIKED, 'loved': this.reelsDetailsListSaved[0].IS_REEL_LIKED }" src="../../../../assets/images/heart.png" alt="Like">
                        <!-- <p>{{ this.reelsDetailsListSaved[0].REEL_LIKES_COUNT }}</p> -->
                  </div>

                  <div class="chat">
                      <button type="button" class="btn p-0" data-bs-toggle="modal" data-bs-target="#message_modal">
                          <img src="../../../../assets/images/bubble-chat.png">
                      </button>
                  </div>
                  <div class="send">
                      <button type="button" class="btn p-0" data-bs-toggle="modal" data-bs-target="#send_message_modal">
                          <img src="../../../../assets/images/send.png">
                      </button>
                  </div>
              </div>
              <div class="save not_saved">
                  <img class="hide saved" src="../../../../assets/images/save_black.png">
                  <img class="not_saved" src="../../../../assets/images/save-instagram.png">
              </div>
          </div>
          <div class="liked">
              <a class="bold" href="#">{{ this.reelsDetailsListSaved[0].REEL_LIKES_COUNT }} likes</a>
          </div>
          <!-- <div class="post_desc">
               
            <input type="text" #commentInput name="comment-input" [(ngModel)]="this.reelsCommentsModel.COMMENT" id="emoji_comment" placeholder="Add a comment..." />

            <button type="button" class="comment-btn" (click)="postComment()">
              <i class="fa fa-paper-plane"></i> 
            </button>
          </div> -->

          <form method="post" cl>
            <div class="input">
              <img src="../../../../assets/images/profile_img.jpg" alt="">
              <input type="text" #commentInput name="comment-input" [(ngModel)]="this.reelsCommentsModel.COMMENT" id="emoji_comment" placeholder="Add a comment..." />
              <button type="button" class="comment-btn" (click)="postComment()">
                <i class="fa fa-paper-plane"></i> <!-- or use an appropriate send icon -->
              </button>

            </div>
          </form>



        </div>
      </div>
     
     
     </div>
   </div>
  
</div>
</div>

  <!-- reels -->
  <div class="d-flex flex-column" >
    <!-- <div class="" style="width: 100%; max-width: 800px; margin: 0 170px 0 auto;">
      <app-category></app-category>
    </div> -->
    
    
    <div tabindex="0" class="reels" *ngIf="currentOption == 'ReelsTab'"
    (focusout)="onFocusOut()"
    (focus)="onFocus()" 
    (window:keydown)="onKeydown($event)" (wheel)="onScroll($event)"
    #reelContainer  
    style="height: 100vh; overflow-y: hidden;"
    >
      <div *ngFor="let video of reelsDetailsList; let i = index" class="reel" [id]="'reel-' + i">
        <div class="video">
          <video #videoElement [id]="'video-' + i" [src]="video.uploadedFilesName" loop></video>
          <div class="content">
            <div class="sound" (click)="toggleReelsMute(i)">
              <img class="volume-up" src="../../../../assets/images/volume-up.png" *ngIf="!video.isMuted">
              <img class="volume-mute" src="../../../../assets/images/volume-mute.png" *ngIf="video.isMuted">
            </div>
            <div class="play" [ngClass]="{'opac_1': !video.isPlaying}" (click)="togglePlay(i)">
              <img src="../../../../assets/images/play-button-arrowhead.png">
            </div>
            <div class="info">
              <div class="profile">
                <h4>
                  <a href="#">
                    <img [src]="video.authorImg">
                    {{ video.authorName }}
                  </a>
                </h4>
                <span>.</span>
                <button class="follow_text">Follow</button>
              </div>
              <div class="desc">
                <p>
                  {{ video.description }}
                  <span class="show_text">more</span>
                </p>
                <div class="more">
                  <div class="music">
                    <img src="../../../../assets/images/music.png">
                    <span>{{ video.musicName }}</span>
                  </div>
                  <div class="position">
                    <img src="../../../../assets/images/map.png">
                    <span>Islamabad</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="likes">
          <div class="like" 
          (click)="isPublicUser == true ? userToken() : toggleLike(i, video)"
          >
            <img [ngClass]="{ 'not_loved': !video.IS_REEL_LIKED, 'loved': video.IS_REEL_LIKED }" src="../../../../assets/images/heart.png" alt="Like">
                <p>{{ !NullCheckFun(video.REEL_LIKES_COUNT) ? 0 : video.REEL_LIKES_COUNT }}</p>
          </div>

          <div class="message">
            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#message_modal" (click)="selectedReel(video.REELS_DETAILS_ID)">
              <img src="../../../../assets/images/bubble-chat.png">
              <p class="m-0">{{video.reelsCommentsModelList.length}}</p>
            </button>
          </div>
          <div class="bookmark-action" 
          (click)="isPublicUser == true ? userToken() : toggleBookmark(i, video)"
          >
            <i *ngIf="!video.isBookmarked" class="bi bi-bookmark"></i>
            <i *ngIf="video.isBookmarked" class="bi bi-bookmark-fill"></i>
        </div>
          <div class="more">
            <img src="../../../../assets/images/show_more.png">
          </div>
          <div class="profile">
            <img src="../../../../assets/images/profile_img.jpg">
          </div>
        </div>
      </div>
    </div>

    <div class="follow-page-container" *ngIf="this.currentOption == 'HomeTab'">
      <h2 class="page-title">Suggested for You</h2>
      <div class="user-list">
        <!-- <div class="user-item" *ngFor="let user of userAccountList">
          <img src="assets/img/user1.jpg" alt="{{user.User_Name}}" class="profile-picture" />
          <div class="user-info">
            <h3 class="username">{{ user.User_Name }}</h3>
            <button class="follow-button" (click)="toggleFollow(user)"
            [ngClass]="user.IS_FOLLOWING ? 'following' : 'follow-button'" 
            >
              {{ user.IS_FOLLOWING ? 'Following' : 'Follow' }}
            </button>
          </div>
        </div> -->

        <div class="row" style="row-gap: 30px;">
          <div class="col-12">
            <div *ngFor="let user of userAccountList" class="user-item-wrapper">
              <div class="user-item d-flex justify-content-between align-items-center">
                <img src="assets/img/user1.jpg" alt="{{user.User_Name}}" class="profile-picture" />
                
                <h4 class="username">{{ user.User_Name }}</h4>
                <button class="follow-button ml-3" (click)="isPublicUser == true ? userToken() : toggleFollow(user)"
                [ngClass]="user.IS_FOLLOWING ? 'following' : 'follow-button'" 
                >
                  {{ user.IS_FOLLOWING ? 'Following' : 'Follow' }}
                </button>
              </div>
            </div>
          </div>
        </div>
    
        

      </div>
    </div>

    <!-- profile page -->

  <div class="profile-page-container" *ngIf="this.currentOption == 'ProfileTab'">
    <div class="profile-header">
      <div class="profile-header-box">
        <img src="assets/img/user1.jpg" alt="Profile Picture" class="profile-picture" />
        <div class="profile-info">
          <h1 class="username">{{this.userReelsAccountModel.User_Name}}</h1>
          <div class="profile-stats">
            <div class="stat">
              <span class="stat-number">{{this.userReelsAccountModel.ReelsCount}}</span>
              <span class="stat-label">Posts</span>
            </div>
            <div class="stat">
              <span class="stat-number">{{this.userReelsAccountModel.FollowersCount}}</span>
              <span class="stat-label">Followers</span>
            </div>
            <div class="stat">
              <span class="stat-number">{{this.userReelsAccountModel.FollowingCount}}</span>
              <span class="stat-label">Following</span>
            </div>
          </div>
          <!-- <button class="edit-profile-button">Edit Profile</button> -->
        </div>
      </div>
    </div>

    <div class="" style="width: 100%; max-width: 857px; margin: 0 170px 0 auto;">
      <!-- <app-category></app-category> -->
      <app-show-users></app-show-users>
    </div>
  
    <div class="profile-content">
      <div class="profile-tabs">
        <button class="tab-button active" 
        [ngClass]="{ '': this.profileTab == 'SaveReelsTab', 'active': this.profileTab == 'PostTab' }"
        (click)="toggleProfileTab('Post')">Posts</button>
        <button class="tab-button" 
        [ngClass]="{ '': this.profileTab == 'PostTab', 'active': this.profileTab == 'SaveReelsTab' }"
        (click)="toggleProfileTab('Save')">Saved Posts</button>
      </div>
      <div class="profile-posts">
        <div class="posts-grid">
          <div *ngIf="this.profileTab == 'PostTab'">            
            <!-- <div *ngFor="let video of userReelsAccount[0].UserReelsDetails; let i = index" class="reel-item">
              <div class="video-wrapper">
                  <video #videoElement [id]="'video-' + i" [src]="video.uploadedFilesName" autoplay loop></video>
              </div>
            </div> -->

            <div *ngFor="let video of userReelsAccount[0].UserReelsDetails; let i = index" class="new-reel-item"
             (click)="togglePopup(video.REELS_DETAILS_ID);togglePopupIndex()">
              <div class="new-video-wrapper">
                <video [id]="'video-' + i" [src]="video.uploadedFilesName" class="new-video"  muted ></video>
              </div>
            </div>
          </div>
          <div *ngIf="this.profileTab == 'SaveReelsTab'">
            <div *ngFor="let video of userReelsAccount[0].UserSavedReelsDetails; let i = index"
             class="new-reel-item">
              <div class="new-video-wrapper">
                  <video  [id]="'video-' + i" [src]="video.uploadedFilesName"  muted ></video>
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
  </div>
  



  
  






  </div>
</div>
<app-common-call></app-common-call>



<!-- <app-footer-style-two></app-footer-style-two> -->